import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import { Forward, Send, Loader2, Landmark, Smile, Minimize2 } from "lucide-react";

export const ReplyDialog = ({ compose, setCompose, onClose, onSend, sending, rewritingReply, appliedReplyTone, onRewrite }) => (
  <Dialog open={!!compose} onOpenChange={(o) => !o && onClose()}>
    <DialogContent data-testid="compose-dialog" className="max-w-lg">
      <DialogHeader>
        <DialogTitle className="flex items-center gap-2">
          {compose?.mode === "forward" ? <><Forward className="h-4 w-4" />Inoltra email</> : <><Send className="h-4 w-4" />Rispondi</>}
        </DialogTitle>
        <DialogDescription className="sr-only">Componi e invia la tua email.</DialogDescription>
      </DialogHeader>
      {compose && (
        <div className="space-y-3">
          <div>
            <label className="text-xs font-semibold text-gray-500">Destinatario</label>
            <Input data-testid="compose-to" value={compose.to} onChange={(e) => setCompose((c) => ({ ...c, to: e.target.value }))} placeholder="email@destinatario.it" className="rounded-md mt-1" />
          </div>
          {compose.mode !== "forward" && (
            <div>
              <label className="text-xs font-semibold text-gray-500">Cc (rispondi a tutti)</label>
              <Input data-testid="compose-cc" value={compose.cc || ""} onChange={(e) => setCompose((c) => ({ ...c, cc: e.target.value }))} placeholder="Altri destinatari, separati da virgola" className="rounded-md mt-1" />
            </div>
          )}
          <div>
            <label className="text-xs font-semibold text-gray-500">Oggetto</label>
            <Input data-testid="compose-subject" value={compose.subject} onChange={(e) => setCompose((c) => ({ ...c, subject: e.target.value }))} className="rounded-md mt-1" />
          </div>
          <div>
            <div className="flex items-center justify-between gap-2 flex-wrap">
              <label className="text-xs font-semibold text-gray-500">Messaggio</label>
              <div className="flex items-center gap-1">
                <span className="text-[10px] text-gray-400 hidden sm:inline">Riscrivi:</span>
                {[["istituzionale", Landmark], ["informale", Smile], ["sintetico", Minimize2]].map(([t, Icon]) => (
                  <button key={t} type="button" data-testid={`reply-rewrite-${t}`} title={`Riscrivi in tono ${t}`}
                    onClick={() => onRewrite(t)} disabled={!!rewritingReply} aria-pressed={appliedReplyTone === t}
                    className={`inline-flex items-center gap-1 h-6 px-1.5 rounded border text-[10px] font-medium disabled:opacity-50 transition-colors duration-150 capitalize ${appliedReplyTone === t ? "border-[#007BFF] bg-[#007BFF]/10 text-[#007BFF]" : "border-gray-200 text-gray-700 hover:bg-gray-100"}`}>
                    {rewritingReply === t ? <Loader2 className="h-3 w-3 animate-spin" /> : <Icon className="h-3 w-3" />}{t}
                  </button>
                ))}
              </div>
            </div>
            <Textarea data-testid="compose-body" value={compose.body} onChange={(e) => setCompose((c) => ({ ...c, body: e.target.value }))} rows={9} className="rounded-md mt-1 text-sm resize-none" />
          </div>
        </div>
      )}
      <DialogFooter>
        <Button variant="outline" onClick={onClose} className="rounded-md">Annulla</Button>
        <Button data-testid="compose-send-button" onClick={onSend} disabled={sending || !compose?.to?.trim()} className="rounded-md bg-[#007BFF] hover:bg-[#0056B3]">
          {sending ? <><Loader2 className="h-4 w-4 mr-2 animate-spin" />Invio…</> : <><Send className="h-4 w-4 mr-2" />Invia</>}
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);
